import { render, staticRenderFns } from "./seguimientoGestion.vue?vue&type=template&id=e66384ec&scoped=true"
import script from "./seguimientoGestion.vue?vue&type=script&lang=js"
export * from "./seguimientoGestion.vue?vue&type=script&lang=js"
import style0 from "./seguimientoGestion.vue?vue&type=style&index=0&id=e66384ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66384ec",
  null
  
)

export default component.exports